import type { AuthResponse } from '../../types/api';
import { cachedRequest, clearApiCache } from './cache';
import { apiFetch, apiRequest } from './client';

export function getCurrentUser(): Promise<AuthResponse> {
  return cachedRequest('auth:me', 5_000, () => apiFetch<AuthResponse>('/api/auth/me'));
}

export function signIn(identifier: string, password: string): Promise<AuthResponse> {
  clearApiCache('auth:');
  return apiFetch<AuthResponse>('/api/auth/signin', {
    method: 'POST',
    body: JSON.stringify({ identifier, password }),
  });
}

export function signUp(username: string, email: string, password: string): Promise<void> {
  return apiRequest('/api/auth/signup', {
    method: 'POST',
    body: JSON.stringify({ username, email, password }),
  });
}

export function signOut(): Promise<void> {
  clearApiCache('auth:');
  return apiRequest('/api/auth/signout', { method: 'POST' });
}
